export default __webpack_public_path__ + "static/media/header.800e32a1.png";